export default [
    // index
    {
        location: 'index.html',
        name: 'gradientTexture',
        type: 'texture',
        path: [
            '/textures/GrainyGradient.png',
        ]
    },
    {
        location: 'index.html',
        name: 'flagTexture',
        type: 'texture',
        path: [
            '/textures/JapaneseFlag.png',
        ]
    },

    // projects
    {
        location: 'projects.html',
        name: 'particleTexture',
        type: 'texture',
        path: [
            '/textures/particles/point.png',
        ]
    },
    {
        location: 'projects.html',
        name: 'smokeTexture',
        type: 'texture',
        path: [
            '/textures/particles/smoke.png',
        ]
    }, 
    {
        location: 'projects.html',
        name: 'earthColorTexture',
        type: 'texture',
        path: [
            '/textures/earth/earthMap.jpeg',
        ]
    },
    {
        location: 'projects.html',
        name: 'earthBumpTexture',
        type: 'texture',
        path: [
            '/textures/earth/earthbump.jpeg',
        ]
    },
    {
        location: 'projects.html',
        name: 'cloudTexture',
        type: 'texture',
        path: [
            '/textures/earth/earthCloud.png',
        ]
    },
    {
        location: 'projects.html',
        name: 'backgroundTexture',
        type: 'texture',
        path: [
            '/textures/spotLight.jpeg',
        ]
    },
    // {
    //     location: 'projects.html',
    //     name: 'ecommerce',
    //     type: 'gltf',
    //     path: [
    //         '/models/ecommerce.glb',
    //     ]
    // },
    // {
    //     location: 'projects.html',
    //     name: 'movie',
    //     type: 'gltf',
    //     path: [
    //         '/models/movie.glb',
    //     ]
    // },
    // {
    //     location: 'projects.html',
    //     name: 'portfolio',
    //     type: 'gltf',
    //     path: [
    //         '/models/portfolio.glb',
    //     ]
    // },
    // {
    //     location: 'projects.html',
    //     name: 'none',
    //     type: 'gltf',
    //     path: [
    //         '/models/none.glb',
    //     ]
    // },
    // skills
    {
        location: 'skills.html',
        name: 'smokeTexture',
        type: 'texture',
        path: [
            '/textures/particles/flame.png',
        ]
    },
    {
        location: 'skills.html',
        name: 'sparkTexture',
        type: 'texture',
        path: [
            '/textures/particles/spark.png',
        ]
    },
    {
        location: 'skills.html',
        name: 'particleTexture',
        type: 'texture',
        path: [
            '/textures/particles/point.png',
        ]
    },
    // Contact
    {
        location: 'contact.html',
        name: 'contacts',
        type: 'gltf',
        path: [
            '/models/contacts.glb',
        ]
    },
    {
        location: 'contact.html',
        name: 'floor',
        type: 'gltf',
        path: [
            '/models/floor.glb',
        ]
    },
]